import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/GI-logo-sign.png'


const _withScopeId = n => (_pushScopeId("data-v-07a9ea40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 p-text-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "p-d-flex p-flex-wrap" }
const _hoisted_5 = { class: "p-d-flex" }
const _hoisted_6 = { class: "main-photo-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Profile image", -1))
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  class: "user-photo"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "select synced image", -1))
const _hoisted_11 = { class: "p-d-flex p-flex-wrap" }
const _hoisted_12 = ["onClick", "src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload" }, null, -1))
const _hoisted_14 = { class: "p-ml-auto" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "About you", -1))
const _hoisted_18 = { class: "p-d-flex p-justify-between p-mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_cropper_image = _resolveComponent("cropper-image")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.show,
    class: "p-col-12 p-md-6 p-xl-4",
    modal: true,
    style: {"width":"100%","max-width":"1314px","background":"white","min-height":"600px","padding":"100px !important"},
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:show', false)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isAgency)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Influencer Info"))
          : _createCommentVNode("", true),
        (_ctx.isAgency)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "Agency Info"))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "p-button-link p-ml-6",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:show', false)))
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            label: "Crop image",
            class: "p-button-text p-button-danger gi-button p-text-uppercase p-mr-6",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCrop = !_ctx.showCrop)),
            disabled: !_ctx.availablePhotos?.length
          }, null, 8, ["disabled"]),
          _createVNode(_component_Button, {
            label: "Save Changes",
            class: "p-button-text p-button-danger gi-button p-text-uppercase p-mr-6",
            onClick: _ctx.updateProfile
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (!_ctx.selectedPhoto)
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.selectedPhoto,
                  class: "user-photo"
                }, null, 8, _hoisted_9))
          ]),
          _createElementVNode("div", null, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePhotos, (photo, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  class: _normalizeClass(["photo-item p-mb-3", [_ctx.selectedPhoto === photo ? 'active' : '']]),
                  onClick: ($event: any) => {_ctx.selectedPhoto = photo; _ctx.currentIndex = index},
                  src: photo,
                  key: `${index}_ph`
                }, null, 10, _hoisted_12))
              }), 128)),
              _createElementVNode("label", null, [
                _createElementVNode("input", {
                  type: "file",
                  name: "photo",
                  accept: "image/*",
                  ref: "uploadPhotoInput",
                  id: "Image",
                  style: {"visibility":"hidden","display":"none"},
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFileUpload()))
                }, null, 544),
                _hoisted_13
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (!_ctx.isAgency)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_15, "Influencer name"))
            : _createCommentVNode("", true),
          (_ctx.isAgency)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_16, "Agency name"))
            : _createCommentVNode("", true),
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
            placeholder: _ctx.isAgency ? 'Enter agency name...' : 'Enter influencer name...',
            class: "w-100 tittle-input"
          }, null, 8, ["modelValue", "placeholder"]),
          _hoisted_17,
          _createVNode(_component_Textarea, {
            class: "textarea",
            modelValue: _ctx.aboutInfluencer,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.aboutInfluencer) = $event)),
            autoResize: false,
            placeholder: "Type here...",
            rows: "6",
            cols: "30"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_component_cropper_image, {
        "show-crop": _ctx.showCrop,
        "onUpdate:showCrop": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showCrop) = $event)),
        "user-view": true,
        image: _ctx.selectedPhoto,
        onChange: _ctx.cropMainImage
      }, null, 8, ["show-crop", "image", "onChange"])
    ]),
    _: 1
  }, 8, ["visible"]))
}